import { ReactComponent as IconMessageMusic } from "assets/svg/message-music.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const tellUsYourStory: SurveyTemplate = {
  icon: <IconMessageMusic />,
  title: "Tell Us Your Story",
  description:
    "Ask fans to tell a story from their lives that relates to the theme of a new release.",
  templateId: "tellUsYourStory",
  template: (v, formState) => ({
    fields: {
      description: { content: { en: formState.title } },
      ...getContestDefaults(formState),
    },
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
    surveyQuestions: [
      {
        type: "TextQuestion",
        id: "question_1",
        multiline: true,
        variants: { mobile: "Headline4", desktop: "Headline3" },
      },
    ],
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-tell-us-yo-ea06c3"
        : "pp-tell-us-yo-27afd3",
    fields: [
      {
        name: "format",
        type: "radio",
        label: "What format is this release?",
        options: ["Single", "EP", "Album"],
        getValidation: (fields) =>
          !!fields.format ? false : "You must select an option.",
      },
      {
        name: "title",
        type: "text",
        label: "What's the title of the release?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.title ? false : "This field cannot be left blank",
      },
      {
        name: "releaseDate",
        type: "text",
        label: "When is it going to be released?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.releaseDate ? false : "This field cannot be left blank",
      },
      {
        name: "about",
        type: "text",
        label:
          "What's the theme/inspiration for the new release or what it's about",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.about ? false : "This field cannot be left blank",
      },
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
